import dayjs from "dayjs";

export function groupDebtsByCategory(debtsForYear, currentYear) {
  const notesDueWithinOneYear = [];
  const notesPayable = [];
  const realEstateDebt = [];

  debtsForYear.forEach((debt) => {
    const maturity = debt.maturity_date ? dayjs(debt.maturity_date) : null;
    const isRealEstate = debt.category === "Real Estate";

    const yearStart = dayjs(`${currentYear}-01-01`);
    const yearEnd = dayjs(`${currentYear}-12-31`);
    const isDueWithinYear = maturity && maturity.isBetween(yearStart, yearEnd, "day", "[]");

    if (isDueWithinYear) {
      notesDueWithinOneYear.push(debt);
    } else if (isRealEstate) {
      realEstateDebt.push(debt);
    } else {
      notesPayable.push(debt);
    }
  });

  return {
    notesDueWithinOneYear,
    notesPayable,
    realEstateDebt,
  };
}
